jQuery(document).ready(function ($) {
  if (document.body.classList.contains("block-editor-page")) return;

  const domReady = (cb) => {
    if (typeof wp !== "undefined" && wp.domReady) wp.domReady(cb);
    else cb();
  };

  const once = (eventName, cb) => {
    document.addEventListener(eventName, cb, { once: true });
  };

  const whenGsapReady = (cb) => {
    if (window.gsap) return cb();
    once("longevity:gsap-ready", cb);
  };

  const whenScrollReady = (cb) => {
    let ran = false;

    const runOnce = () => {
      if (ran) return;
      ran = true;
      cb();
    };

    once("longevity:scroll-ready", runOnce);
    setTimeout(runOnce, 0);
  };

  domReady(() => {
    whenGsapReady(() => {
      whenScrollReady(() => {
        initOverlapCTA();
      });
    });
  });

  function initOverlapCTA() {
    const blocks = document.querySelectorAll(".js-overlap-cta");
    if (!blocks.length) return;

    if (typeof window.gsap === "undefined") return;
    const gsap = window.gsap;

    const ScrollTrigger =
      window.ScrollTrigger ||
      (gsap.core && gsap.core.globals && gsap.core.globals().ScrollTrigger);

    if (!ScrollTrigger) return;

    try {
      gsap.registerPlugin(ScrollTrigger);
    } catch (e) {}

    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    blocks.forEach((block) => {
      if (block.dataset.ocInit === "1") return;
      block.dataset.ocInit = "1";

      const entranceItems = block.querySelectorAll(".js-oc-item");
      const c1 = block.querySelector(".overlap-cta__circle--one");
      const c2 = block.querySelector(".overlap-cta__circle--two");

      if (!reduceMotion && entranceItems.length) {
        gsap.set(entranceItems, { autoAlpha: 0, y: 18 });
        if (c1) gsap.set(c1, { rotate: -2, scale: 0.98, autoAlpha: 0 });
        if (c2) gsap.set(c2, { rotate: 2, scale: 0.98, autoAlpha: 0 });

        const tlIn = gsap.timeline({
          defaults: { ease: "power3.out", duration: 0.9 },
          scrollTrigger: { trigger: block, start: "top 80%", once: true },
        });

        if (c1) tlIn.to(c1, { autoAlpha: 1, scale: 1, rotate: 0 }, 0);
        if (c2) tlIn.to(c2, { autoAlpha: 1, scale: 1, rotate: 0 }, 0.06);
        tlIn.to(entranceItems, { autoAlpha: 1, y: 0, stagger: 0.12 }, 0.08);
      } else if (reduceMotion && entranceItems.length) {
        gsap.set(entranceItems, { autoAlpha: 1, y: 0 });
        if (c1) gsap.set(c1, { autoAlpha: 1, scale: 1, rotate: 0 });
        if (c2) gsap.set(c2, { autoAlpha: 1, scale: 1, rotate: 0 });
      }

      const containers = block.querySelectorAll(".js-highlight-text");
      if (!containers.length) return;

      containers.forEach((container) => {
        if (container.dataset.split === "1") return;
        container.dataset.split = "1";

        const targets = container.querySelectorAll("p").length
          ? container.querySelectorAll("p")
          : [container];

        const allWords = [];

        targets.forEach((node) => {
          const text = (node.textContent || "").trim();
          if (!text) return;

          const words = text.split(/\s+/).filter(Boolean);

          node.innerHTML = words
            .map((w) => `<span class="overlap-cta__w">${escapeHtml(w)}</span>`)
            .join(" ");

          allWords.push(...node.querySelectorAll(".overlap-cta__w"));
        });

        if (!allWords.length) return;

        if (reduceMotion) {
          gsap.set(allWords, { opacity: 1 });
          return;
        }

        gsap.set(allWords, { opacity: 0.3 });

        gsap
          .timeline({
            scrollTrigger: {
              trigger: block,
              start: "top 75%",
              end: "top 35%",
              scrub: true,
            },
          })
          .to(allWords, {
            opacity: 1,
            ease: "none",
            stagger: { each: 0.05, from: "start" },
          });
      });
    });
  }

  function escapeHtml(str) {
    return String(str)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }
});
